import { type FC } from 'react'

import { useIsPanelOpen } from 'stores/usePanelsStateStore'
import { cn } from 'utils/cn'

import { ConversationHistoryHeader } from './ConversationHistoryHeader'
import { ConversationHistorySearchInput } from './ConversationMenuSearchInput'
import { GroupedConversations } from './GroupedConversations'

export const ConversationHistory: FC = () => {
  const isConversationMenuPanelOpen = useIsPanelOpen('conversations_menu')

  return (
    <>
      <ConversationHistoryHeader />

      {isConversationMenuPanelOpen && <ConversationHistorySearchInput />}

      <div
        className={cn(
          'flex-col w-full flex-1 mt-1 overflow-visible conversation-history-container scrollbar-gutter-stable',
          {
            flex: isConversationMenuPanelOpen,
            hidden: !isConversationMenuPanelOpen,
          },
        )}
      >
        <GroupedConversations />
      </div>
    </>
  )
}
